module.exports = __webpack_public_path__ + "img/logo-hw.9731557c.png";